import React, {useState} from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import

import Checkbox from '../forms/Checkbox.js';
import api from '../../api/index.js';
import ShowIff from '../ui/ShowIff.js';
import ConfirmUI from '../ui/Confirm.js';
import WageHistory from './wagehistory.js';

const EmployeeForm = (props) => {
	// Adds or edits employee data
	console.log(props);
	const [firstName, setFirstName] = useState(props.FirstName || props.filter || '');
	const [lastName, setLastName] = useState(props.LastName || '');
	const [isActive, setIsActive] = useState(props.Visible || 'Y');
	
	const changeFirstName = (e) => { setFirstName(e.target.value); }
	const changeLastName = (e) => { setLastName(e.target.value); }
	const changeIsActive = (e) => { setIsActive(e.target.checked ? 'Y' : 'N'); }
	
	const save = async (e) => {
		e.preventDefault();
		
		const data = {
			FirstName: firstName,
			LastName: lastName,
			Visible: isActive
		};
		if (props.hasOwnProperty('EmployeeID') === false) {
			try {
				let r = await api.post('employees', data);
				api.success('Employee added', r);
				console.log("onAdded", props.onAdded);
				if (props.onAdded)
					props.onAdded({EmployeeID: r, ...data});
			} catch(e) {
				api.handleExceptions(e);
			};
		} else {
			console.log("Update employee");
			try {
				let r = await api.put('employees/' + props.EmployeeID, data);
				api.success('Employee updated', r);
				if (props.onUpdated)
					props.onUpdated(props.EmployeeID);
			} catch(e) {
				api.handleExceptions(e);
			};
		}
	}
	
	
	const deleteClick = (e) => {
		e.preventDefault();
		confirmAlert({
			title: 'Permanently delete this user: '  + props.FirstName + ' ' + props.LastName,
			customUI: ConfirmUI(
				deleteUser, 
				<div><p className="red"><em><strong>This is not a safe action.</strong></em></p><p>Avoid this unless you've entered a user by mistake. Are you sure you want to do this?</p></div>
			),
		});
	}
	
	const deleteUser = async (e) => {
		try {
			let r = await api.del('employees/' + props.EmployeeID);
			api.success('Employee deleted', r);
			if (props.onDelete)
				props.onDelete(props.EmployeeID);
		} catch(e) {
			api.handleExceptions(e);
		};
	}

	return <React.Fragment><form className={(props.className || '') + ' EmployeeForm'} onSubmit={save}>
		<label>First name</label>
		<input type="text" name="FirstName" placeholder="First Name" value={firstName} onChange={changeFirstName} />
		<label>Last name</label>
		<input type="text" name="LastName" placeholder="Last Name" value={lastName} onChange={changeLastName} />
		<label><Checkbox type="checkbox" name="isActive" checked={isActive === 'Y'} onChange={changeIsActive} /> Is Active</label>
		<div className="button-holder">
			<button className="block" type="submit">Save</button>
			<ShowIff iff={props.EmployeeID}>
				<button className="block red" onClick={deleteClick}>Delete</button>
			</ShowIff>
		</div>
	</form>
	<ShowIff iff={props.EmployeeID}>
		<p>Current wage: <WageHistory EmployeeID={props.EmployeeID} placeholder={props.HourlyRate ? props.HourlyRate.Rate : false} onUpdated={()=>{if (props.onSoftUpdated) props.onSoftUpdated(props.EmployeeID)}} /></p>
	</ShowIff>
	</React.Fragment>;
}
export default EmployeeForm;